import messages from "./messages";

export const contactPageConfig = [
  { id: "name", value: messages.name, prefix: "", link: "", localized: true },
  { id: "position", value: messages.position, prefix: "", link: "", localized: true },
  { id: "phone", value: "+49 621 60 27114", prefix: "Tel.", link: "", localized: false },
  {
    id: "email",
    value: "ivan.zlatkovic@basf.com",
    prefix: "e-mail:",
    link: "mailto:ivan.zlatkovic@basf.com",
    localized: false,
  },
];
